import * as swcHelpers from '@swc/helpers';
import { takeLatest, call } from 'redux-saga/effects';
import { pushEvent } from './actions.js';
import { pushEvent as pushEvent$1 } from './helpers.js';

function* onPushEvent(action) {
    /**
   * We copy the payload object here so GTM doesn't mutate it by adding a "gtm.uniqueEventId" property
   * onto it. This property will be added onto every GTM event, but we don't need it added onto our action payload.
   */ yield call(pushEvent$1, swcHelpers.objectSpread({}, action.payload));
}
var dataLayerSagas = [
    takeLatest(pushEvent.type, onPushEvent)
];

export { dataLayerSagas as default, onPushEvent };
//# sourceMappingURL=sagas.js.map
